import { SkillForm } from "@/core/skillForms/types";
import { legalQuestionSkillStep1 } from "./step1";

export const legalQuestionSkillForm: SkillForm = {
  skillId: "legal_questions",
  title: "Dúvida jurídica",
  steps: [legalQuestionSkillStep1],
};
